import { useEffect } from 'react';

import { trackSearchResult } from '@/utilities/tracking';

export const useSearchResultTracking = (totalItemCount?: number) => {
  useEffect(() => {
    const { searchParams } = new URL(document.location.href);
    const searchQuery = searchParams.get('SearchTerm') ?? searchParams.get('q');

    if (searchQuery) {
      trackSearchResult({
        searchTerm: searchQuery,
        searchResult: totalItemCount ?? 0,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
